import { formatDateTime, MedplumClient } from "@medplum/core";

export const searchResource = async (
  medplum: MedplumClient,
  resourceType: any,
  payload: any
) => {
  const resource = await medplum.searchResources(resourceType, payload);

  return resource;
};
export function mapAuditEvents(auditEvents: any) {
  const mappedEvents = auditEvents.map((audit: any) => {
    return {
      id: audit?.id,
      agent: capitalizeFirstLetter(
        audit?.agent?.[0]?.type?.text ??
          auditEvents[0]?.agent?.[0]?.who?.display ??
          "--"
      ),
      entity: audit?.entity?.map(
        (e: any) => capitalizeFirstLetter(e?.what?.display) ?? "--"
      )??'--',
      outcome: audit?.outcome,
      outComeDesc:
        audit?.outcomeDesc ??
        `${audit?.type?.display ?? ""} --  ${
          audit?.subtype?.[0]?.display ?? ""
        }`,
      recorded: formatDateTime(audit?.recorded),
    };
  });

  return mappedEvents.sort((a: any, b: any) =>
    a.outComeDesc === "--" ? 1 : b.outComeDesc === "--" ? -1 : 0
  );
}

const capitalizeFirstLetter = (string: any) =>
  string?.charAt(0).toUpperCase() + string?.slice(1);
 

export function mapStatusToOutcome(status: string): number {
  const statusToOutcomeMap: any = {
    "show all":["0",'4','8','12'],
    success: '0',
    "minor failure": '4',
    "serious failure": '8',
    "major failure": '12',
  };

  return statusToOutcomeMap[status] ;
}
